import {useIsMobile} from 'hooks/is_mobile';
import React from 'react';
import {classNames} from 'utils';
import styles from './sticky.module.css';

const HEADER_HEIGHT = 80;

export const Sticky = ({
  threshold = 20,
  shadow = false,
  disabled = false,
  zIndexOffset = 0,
  children,
}: Props) => {
  const isMobile = useIsMobile();
  if (disabled) return <>{children}</>;

  return (
    <div
      style={{
        top: (isMobile ? 0 : HEADER_HEIGHT) + threshold,
        zIndex: `calc(var(--iq-z-index-sticky) + ${zIndexOffset})`,
      }}
      className={classNames([styles.sticky, shadow && styles.hasShadow])}>
      {children}
      {shadow && (
        <>
          <div style={{height: threshold}} className={styles.topShadow} />
          <div style={{height: threshold}} className={styles.bottomShadow} />
        </>
      )}
    </div>
  );
};

type Props = {
  threshold?: number;
  shadow?: boolean;
  disabled?: boolean;
  zIndexOffset?: number;
  children?: React.ReactNode;
};
